module.exports = [
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 48595,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=48595&type=card",
		"name": "Predator's Strike"
	},
	{
		"id": 48595,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=48595&type=card",
		"name": "Predator's Strike"
	},
	{
		"id": 48595,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=48595&type=card",
		"name": "Predator's Strike"
	},
	{
		"id": 48595,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=48595&type=card",
		"name": "Predator's Strike"
	},
	{
		"id": 397717,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397717&type=card",
		"name": "Mutagenic Growth"
	},
	{
		"id": 397717,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397717&type=card",
		"name": "Mutagenic Growth"
	},
	{
		"id": 397717,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397717&type=card",
		"name": "Mutagenic Growth"
	},
	{
		"id": 397717,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397717&type=card",
		"name": "Mutagenic Growth"
	},
	{
		"id": 401657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=401657&type=card",
		"name": "Groundswell"
	},
	{
		"id": 401657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=401657&type=card",
		"name": "Groundswell"
	},
	{
		"id": 401657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=401657&type=card",
		"name": "Groundswell"
	},
	{
		"id": 401657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=401657&type=card",
		"name": "Groundswell"
	},
	{
		"id": 397768,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397768&type=card",
		"name": "Apostle's Blessing"
	},
	{
		"id": 397768,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397768&type=card",
		"name": "Apostle's Blessing"
	},
	{
		"id": 397768,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397768&type=card",
		"name": "Apostle's Blessing"
	},
	{
		"id": 397768,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397768&type=card",
		"name": "Apostle's Blessing"
	},
	{
		"id": 397747,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397747&type=card",
		"name": "Vines of Vastwood"
	},
	{
		"id": 397747,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397747&type=card",
		"name": "Vines of Vastwood"
	},
	{
		"id": 397747,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397747&type=card",
		"name": "Vines of Vastwood"
	},
	{
		"id": 397747,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397747&type=card",
		"name": "Vines of Vastwood"
	},
	{
		"id": 194158,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194158&type=card",
		"name": "Blight Mamba"
	},
	{
		"id": 194158,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194158&type=card",
		"name": "Blight Mamba"
	},
	{
		"id": 194158,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194158&type=card",
		"name": "Blight Mamba"
	},
	{
		"id": 194158,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194158&type=card",
		"name": "Blight Mamba"
	},
	{
		"id": 233052,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=233052&type=card",
		"name": "Glistener Elf"
	},
	{
		"id": 233052,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=233052&type=card",
		"name": "Glistener Elf"
	},
	{
		"id": 233052,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=233052&type=card",
		"name": "Glistener Elf"
	},
	{
		"id": 233052,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=233052&type=card",
		"name": "Glistener Elf"
	},
	{
		"id": 413722,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413722&type=card",
		"name": "Rancor"
	},
	{
		"id": 413722,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413722&type=card",
		"name": "Rancor"
	},
	{
		"id": 413722,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413722&type=card",
		"name": "Rancor"
	},
	{
		"id": 413722,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413722&type=card",
		"name": "Rancor"
	},
	{
		"id": 194256,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194256&type=card",
		"name": "Ichorclaw Myr"
	},
	{
		"id": 194256,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194256&type=card",
		"name": "Ichorclaw Myr"
	},
	{
		"id": 194256,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194256&type=card",
		"name": "Ichorclaw Myr"
	},
	{
		"id": 194256,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=194256&type=card",
		"name": "Ichorclaw Myr"
	},
	{
		"id": 393898,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=393898&type=card",
		"name": "Giant Growth"
	},
	{
		"id": 393898,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=393898&type=card",
		"name": "Giant Growth"
	},
	{
		"id": 393898,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=393898&type=card",
		"name": "Giant Growth"
	},
	{
		"id": 393898,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=393898&type=card",
		"name": "Giant Growth"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./decks/infect.json
 ** module id = 438
 ** module chunks = 0
 **/